import React from 'react';
import ChaveApp from './ChaveApp';
import VincularChaveApp from './VincularChaveApp';

export const ChaveConfig = {
    settings: {
        layout: {
            config: {}
        }
    },
    routes: [
        {
            path: '/:organizacao/:empresa/convite',
            component: () => <ChaveApp tipo={1} Label={"Convites"} />
        },
        {//PENDENTE
            path: '/:organizacao/:empresa/licenca',
            component: () => <ChaveApp tipo={2} Label={"Licença"} />
        },
        {//PENDENTE
            path: '/:organizacao/:empresa/chave',
            component: () => <ChaveApp tipo={3} Label={"Chave"} />
        },
        {//PENDENTE
            path: '/:organizacao/:empresa/vincularcomchave/:codigo',
            component: () => <VincularChaveApp tipo={1} />
        },
    ]
};
